import React from "react";

export default function Signal4({
  fill = "black",
  width = "40px",
  height = "40px",
  ...others
}) {
  return (
    <svg 
    width={width}
    height={height}
    viewBox="0 0 700 500" 
    xmlns="http://www.w3.org/2000/svg"
    {...others}>
     <g>
  <path d="m198.05 340.07c-2.3828 0.003906-4.668 0.95312-6.3516 2.6406-1.6797 1.6875-2.625 3.9727-2.6211 6.3555v69.055c-0.003906 2.3789 0.94141 4.6641 2.625 6.3516 1.6836 1.6875 3.9648 2.6328 6.3477 2.6367h55.262c2.3828-0.003906 4.668-0.94922 6.3477-2.6367 1.6836-1.6875 2.6289-3.9727 2.625-6.3516v-69.055c0.003907-2.3828-0.9375-4.668-2.6211-6.3555-1.6836-1.6875-3.9688-2.6367-6.3516-2.6406z" fill={fill}/>
  <path d="m280.93 271.03c-4.9531 0-8.9688 4.0156-8.9727 8.9688v138.12c0 2.3789 0.94141 4.6641 2.625 6.3516 1.6836 1.6875 3.9688 2.6328 6.3477 2.6367h55.262c2.3828-0.003906 4.668-0.94922 6.3516-2.6367 1.6797-1.6875 2.625-3.9727 2.6211-6.3516v-138.12c-0.003906-4.9531-4.0156-8.9688-8.9727-8.9688z" fill={fill}/>
  <path d="m363.81 201.96c-4.957 0.003906-8.9688 4.0195-8.9727 8.9727v207.19c-0.003907 2.3789 0.94141 4.6641 2.6211 6.3516 1.6836 1.6875 3.9688 2.6328 6.3516 2.6367h55.262c2.3789-0.003906 4.6641-0.94922 6.3477-2.6367 1.6836-1.6875 2.625-3.9727 2.625-6.3516v-207.19c-0.003907-4.9531-4.0195-8.9688-8.9727-8.9727z" fill={fill}/>
  <path d="m446.68 132.89c-2.3828 0-4.668 0.94922-6.3516 2.6367-1.6836 1.6875-2.625 3.9727-2.6211 6.3555v276.25c-0.003907 2.3789 0.94141 4.6641 2.625 6.3516 1.6797 1.6875 3.9648 2.6328 6.3477 2.6367h55.262c2.3828-0.003906 4.6641-0.94922 6.3477-2.6367 1.6836-1.6875 2.6289-3.9727 2.625-6.3516v-276.25c0.003906-2.3828-0.94141-4.668-2.6211-6.3555-1.6836-1.6875-3.9688-2.6367-6.3516-2.6367z" fill={fill}/>
 </g>
    </svg>
  );
}
